
import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface FocusUnderlineProps {
  isActive: boolean;
  isDark?: boolean;
}

const FocusUnderline: React.FC<FocusUnderlineProps> = ({ 
  isActive, 
  isDark = false 
}) => {
  return (
    <motion.div 
      className={cn(
        "absolute bottom-0 left-0 h-0.5 bg-primary rounded-full",
        isDark ? "bg-primary" : "bg-primary"
      )}
      initial={{ width: 0, opacity: 0 }}
      animate={{ 
        width: isActive ? "100%" : "0%",
        opacity: isActive ? 1 : 0
      }}
      transition={{ duration: 0.3 }}
    />
  );
};

export default FocusUnderline;
